export interface TableRowHintData {
  learnedTables: Record<string, boolean>;
}

export interface TableRowHintActions {
  markLearned: (tableKey: string) => void;
}

export type TableRowHintState = TableRowHintData & TableRowHintActions;

export const TABLE_ROW_HINT_INITIAL_STATE: TableRowHintData = {
  learnedTables: {}
};
